export const ASSOCIATED_COMPANIES_CARD_TAG_NAME = 'tm-bo-associated-companies-card';
